// Daily / weekly / monthly boundary helpers.
//
// All boundaries are computed in the client's local timezone using Date's
// local-time constructor (new Date(year, month, day, ...)). Week boundaries
// follow the ISO standard: Monday is the first day of the week, Sunday is
// the last.

/**
 * Returns millisecond boundaries for "today", "this week" (Mon-Sun), and
 * "this month", based on the provided reference date (defaults to now).
 *
 * @param {Date} [now=new Date()] - Reference point. Exposed for testing.
 * @returns {{
 *   todayStart: number, todayEnd: number,
 *   weekStart: number,  weekEnd: number,
 *   monthStart: number, monthEnd: number,
 * }}
 */
export function getDailyWeeklyMonthlyRanges(now = new Date()) {
  const year = now.getFullYear();
  const month = now.getMonth();
  const date = now.getDate();

  const todayStart = new Date(year, month, date).getTime();
  const todayEnd = new Date(year, month, date, 23, 59, 59, 999).getTime();

  // ISO week: Monday = 0, ..., Sunday = 6. getDay() returns 0 for Sunday,
  // so (getDay() + 6) % 7 shifts Sunday from 0 to 6 and Monday from 1 to 0.
  const daysSinceMonday = (now.getDay() + 6) % 7;
  const weekStart = new Date(year, month, date - daysSinceMonday).getTime();
  const weekEnd = new Date(year, month, date + (6 - daysSinceMonday), 23, 59, 59, 999).getTime();

  const monthStart = new Date(year, month, 1).getTime();
  // Day 0 of the next month = last day of the current month.
  const monthEnd = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();

  return { todayStart, todayEnd, weekStart, weekEnd, monthStart, monthEnd };
}
